console.log("1");

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");

      console.log(cartItems);

      // Bundles
      if (this.closest(".cart-item").dataset.bundle) {
        const bundle = JSON.parse(this.closest(".cart-item").dataset.bundle);
        const line = this.closest(".cart-item").dataset.index;
        cartItems.enableLoading(line);

        // Set the config
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        config.headers["Content-Type"] = "application/json";
        config.method = "POST";
        const obj = {};
        bundle.items.map(({ key }) => {
          return (obj[`${key}`] = 0);
        });
        config.body = JSON.stringify({
          sections: cartItems
            .getSectionsToRender()
            .map((section) => section.id),
          sections_url: window.location.pathname,
          updates: obj,
        });
        fetch(`${routes.cart_update_url}`, config)
          .then((response) => response.text())
          .then((state) => {
            const parsedState = JSON.parse(state);
            cartItems.classList.toggle(
              "is-empty",
              parsedState.item_count === 0
            );
            const cartDrawerWrapper = document.querySelector("cart-drawer");
            const cartFooter = document.getElementById("main-cart-footer");

            if (cartFooter)
              cartFooter.classList.toggle(
                "is-empty",
                parsedState.item_count === 0
              );
            if (cartDrawerWrapper)
              cartDrawerWrapper.classList.toggle(
                "is-empty",
                parsedState.item_count === 0
              );

            cartItems.getSectionsToRender().forEach((section) => {
              const elementToReplace =
                document
                  .getElementById(section.id)
                  .querySelector(section.selector) ||
                document.getElementById(section.id);
              elementToReplace.innerHTML = cartItems.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            });

            cartItems.updateLiveRegions(line, parsedState.item_count);
            const lineItem =
              document.getElementById(`CartItem-${line}`) ||
              document.getElementById(`Drawer-cartItem-${line}`);
            if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
              cartDrawerWrapper
                ? trapFocus(
                    cartDrawerWrapper,
                    lineItem.querySelector(`[name="${name}"]`)
                  )
                : lineItem.querySelector(`[name="${name}"]`).focus();
            } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
              trapFocus(
                cartDrawerWrapper.querySelector(".drawer__inner-empty"),
                cartDrawerWrapper.querySelector("a")
              );
            } else if (
              document.querySelector(".cart-item") &&
              cartDrawerWrapper
            ) {
              trapFocus(
                cartDrawerWrapper,
                document.querySelector(".cart-item__name")
              );
            }
            cartItems.disableLoading();
          })
          .then(() => {
            cartItems.bundles();
          });

        return;
      }

      // If this is a GWP threshold product, add it to Local Storage so it is not auto added again
      if (this.dataset.isGwpThresholdProduct) {
        const gwpLocalStorage = localStorage.getItem("gwpThresholdRemoved")
          ? JSON.parse(localStorage.getItem("gwpThresholdRemoved"))
          : false;
        const localStorageArray = gwpLocalStorage || [];
        const itemId = this.dataset.itemId;
        if (itemId) {
          // Check if item is already in storage and bail if so
          if (!localStorageArray.includes(itemId)) {
            localStorageArray.push(this.dataset.itemId);
            localStorage.setItem(
              "gwpThresholdRemoved",
              JSON.stringify(localStorageArray)
            );
          }
        }
      }

      // Remove GWP child product if one is set
      // ...
      // Set empty gwp_product_to_remove
      let gwp_product_to_remove = 0;
      // Set child ID
      const childId = Number(this.dataset.gwpChildId) || 0;
      // Check child ID
      if (childId) {
        // Set cart items
        const cartItemsArray = Array.from(
          cartItems.querySelectorAll(".cart-item")
        );
        // Find the child item in cart items
        const found = cartItemsArray.find(
          (item) => item.dataset.itemId == childId
        );
        // If found set the GWP product to the item's key (Shopify generated UID for cart item)
        if (found) {
          gwp_product_to_remove = found.dataset.itemKey;
        }
      }
      cartItems.updateQuantity(
        this.dataset.index,
        0,
        "",
        gwp_product_to_remove
      );
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.bundles();
    this.gwp();

    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("shopping-cart-drawer-line-item-status");

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
      this.gwp();
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  bundles() {
    const items = this.querySelectorAll(".js-cart-item");
    const cloneTarget = this.querySelector(".cart-items tbody");
    const bundles = {};

    console.log(items);

    items.forEach((item) => {
      if (item.dataset.bundleId) {
        const title = item.dataset.title;
        const quantity = item.dataset.quantity;
        const price = (Number(item.dataset.price) / 100) * quantity;
        const index = item.dataset.index;
        const key = item.dataset.itemKey;
        const id = item.dataset.bundleId;
        const variant = item.dataset.variantTitle;
        const image = item.dataset.cartImage;

        if (!bundles[id]) {
          bundles[id] = {
            price: price,
            image: image,
            items: [
              {
                title: title,
                index: index,
                key: key,
                quantity: quantity,
                variant: variant,
              },
            ],
          };
        } else {
          bundles[id].price = Number(bundles[id].price) + Number(price);
          (bundles[id].image = image),
            bundles[id].items.push({
              title: title,
              index: index,
              key: key,
              quantity: quantity,
              variant: variant,
            });
        }
      }
    });

    let line = items.length;
    const template = this.querySelector(".js-cart-item-template");

    Object.entries(bundles).forEach(([id, bundle]) => {
      line++;
      const clone = template.cloneNode(true);
      const priceElements = clone.querySelectorAll("[data-price]");
      priceElements.forEach((element) => {
        element.textContent = `£${bundle.price.toFixed(2)}`;
      });

      const linkElement = clone.querySelector("[data-link]");
      const linkString = `/collections/create-a-gift-box?view=bundle-builder&bagId=${id}`;
      linkElement.href = linkString;

      const titleElement = clone.querySelector("[data-title]");
      titleElement.innerHTML += "<br>";
      const itemList = bundle.items
        .map(({ title, quantity, variant }) => {
          const variantString = variant ? ` (${variant})` : "";
          return `${quantity}x ${title}${variantString}`;
        })
        .join("<br>");
      titleElement.innerHTML += itemList;

      const quantityElement = clone.querySelector("[data-quantity]");
      const quantity = bundle.items.reduce(
        (acc, { quantity }) => acc + parseInt(quantity),
        0
      );
      quantityElement.textContent = `${quantity} items`;

      const imageElement = clone.querySelector("[data-image]");
      if (imageElement && bundle.image) {
        imageElement.src = bundle.image;
      }

      clone.classList.remove("hidden");
      clone.dataset.bundle = JSON.stringify(bundle);
      clone.dataset.index = line;
      clone.dataset.bundleId = id;
      clone.id = `CartItem-${line}`;
      cloneTarget.innerHTML += clone.outerHTML;
    });
  }

  gwp() {
    // GWP Thresholds
    const gwpLocalStorage = localStorage.getItem("gwpThresholdRemoved")
      ? JSON.parse(localStorage.getItem("gwpThresholdRemoved"))
      : false;
    const gwpLocalStorageArray = gwpLocalStorage ? gwpLocalStorage : [];
    this.cart =
      document.querySelector("cart-items") ||
      document.querySelector("cart-drawer");
    // Get the threshold items
    const thresholds = document.querySelectorAll(".js-gwp-threshold");
    // If there are threshold items set from the Theme Editor
    if (thresholds.length) {
      fetch(window.Shopify.routes.root + "cart.js")
        .then((response) => response.text())
        .then((state) => {
          const json = JSON.parse(state);
          const cartTotal = json.total_price / 100;
          const cartItemIds = json.items.map(({ id }) => id);
          const activeThresholds = Array.from(thresholds)
            .filter((item) => item.dataset.threshold)
            .filter((item) => item.dataset.product)
            .filter(
              (item) => !gwpLocalStorageArray.includes(item.dataset.product)
            )
            .filter(
              (item) => !cartItemIds.includes(parseInt(item.dataset.product))
            )
            .filter(
              (item) =>
                parseFloat(item.dataset.threshold) <= parseFloat(cartTotal)
            );

          // Bail if no items to process
          if (!activeThresholds.length) return;

          // Set the config
          const config = fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          config.headers["Content-Type"] = "application/json";
          config.method = "POST";
          // Set the initial body of the call
          let body = {
            sections: this.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname,
            items: [
              {
                id: 0,
                quantity: 1,
              },
            ],
          };
          // Loop each threshold element
          activeThresholds.forEach((item) => {
            // Set the individual config
            body.items[0].id = Number(item.dataset.product);
            body.items[0].properties = {
              _is_gwp_threshold_product: true,
            };
            config.body = JSON.stringify(body);
            // Add the product(s) to cart
            fetch("/cart/add.js", config)
              .then((response) => response.text())
              .then((state) => {
                const parsedState = JSON.parse(state);
                this.getSectionsToRender().forEach((section) => {
                  const elementToReplace =
                    document
                      .getElementById(section.id)
                      .querySelector(section.selector) ||
                    document.getElementById(section.id);
                  elementToReplace.innerHTML = this.getSectionInnerHTML(
                    parsedState.sections[section.section],
                    section.selector
                  );
                });
              })
              .catch((e) => {
                console.error(e);
              });
          });
        });
    }
  }

  onChange(event) {
    console.log("ON CHANGE");
    console.log(this);

    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: "main-cart-items",
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: "main-cart-footer",
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name, gwp) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`Drawer-cartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }
        this.disableLoading();
      })
      .then(() => {
        // If GWP has been passed then remove it from cart
        if (gwp) {
          const cartItems =
            this.closest("cart-items") || this.closest("cart-drawer-items");
          if (cartItems) {
            const cartItemsArray = Array.from(
              cartItems.querySelectorAll(".cart-item")
            );
            const found = cartItemsArray.find(
              (item) => item.dataset.itemKey == gwp
            );
            if (found) {
              cartItems.updateQuantity(found.dataset.index, 0);
            }
          }
        }
      })
      .catch((e) => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("drawer-cart-errors");
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError =
        document.getElementById(`Line-item-error-${line}`) ||
        document.getElementById(`Cart-drawer-line-item-error-${line}`);
      const quantityElement =
        document.getElementById(`Quantity-${line}`) ||
        document.getElementById(`Drawer-quantity-${line}`);

      lineItemError.querySelector(".cart-item__error-text").innerHTML =
        window.cartStrings.quantityError.replace(
          "[quantity]",
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("cart-drawer-live-region-text");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("drawer-main-cart-items");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#Drawer-cartItem-${line} .loading-overlay`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading() {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("drawer-main-cart-items");
    mainCartItems.classList.remove("cart__items--disabled");
  }
}

customElements.define("cart-items", CartItems);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
